import { ArrowIcon } from "@design-system/icons";

export function ScrollToTopButton() {
  return (
    <button
      aria-label="Scroll to top"
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }}
      className="flex size-12 items-center justify-center rounded-full border border-white transition-colors duration-200 hover:bg-secondary lg:size-16"
    >
      <ArrowIcon />
    </button>
  );
}
